<script lang="ts">
	import Text from '../../../Text.svelte';
	import InterestList from '../../InterestList.svelte';
	import { interestListFormatter } from '../../../../utils';
	import { interests as interestList } from '../../../../stores';

	export let row: any;
</script>

<div class="income">
	{#if !((row.lookalikeId !== '' && row.lookalikeId !== null) || (row.targetId !== '' && row.targetId !== null))}
		<Text type="body1">{row.certaintyIncome * 100}%</Text>
		<InterestList
			operator={row.operator}
			interestList={interestListFormatter(row.income, $interestList)}
		/>
	{/if}
</div>

<style>
	.income {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
	}
</style>
